import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import theme from '../../constants/theme'
import {
  SideCard,
  CardSectionHeader,
  CardIconBox,
  CompanyDivider,
  SectionSubLabel,
  BlockTypography,
  Typography,
} from '../styled'
import Briefcase from '../../assets/svgs/Briefcase'

function JobDetails({ desc, positionName, startDate, endDate }) {
  const { t } = useTranslation()

  const strippedDesc = desc?.replace(/<[^>]+>|&nbsp;|\u00A0/g, ' ')?.trim()

  return (
    <SideCard
      style={{
        maxHeight: '400px',
        overflowY: 'auto',
      }}
    >
      <CardSectionHeader mb="0">
        <CardIconBox>
          <Briefcase width="15" height="15" color={theme.brandColorOrange} />
        </CardIconBox>
        <BlockTypography bold size="15px" color={theme.talentinoBlack}>
          {positionName}
        </BlockTypography>
      </CardSectionHeader>

      {strippedDesc && (
        <>
          <CompanyDivider />
          <SectionSubLabel>{t('card.description')}</SectionSubLabel>
          <Typography size="13px" color={theme.talentinoSecondaryGray}>
            {strippedDesc}
          </Typography>
        </>
      )}

      <CompanyDivider />
      <SectionSubLabel>{t('card.startDate')}</SectionSubLabel>
      <Typography size="13px" color={theme.talentinoSecondaryGray}>
        {startDate}
      </Typography>

      <CompanyDivider />
      <SectionSubLabel>{t('card.endDate')}</SectionSubLabel>
      <Typography size="13px" color={theme.talentinoSecondaryGray}>
        {endDate}
      </Typography>
    </SideCard>
  )
}

JobDetails.propTypes = {
  desc: PropTypes.string,
  positionName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

export default JobDetails
